import * as React from 'react';
import { observer } from 'mobx-react-lite';
import type { AssetCommonViewProps } from 'owa-timestream-asset-sdk-types';
import ClockViewHeader from './ClockViewHeader';
import ClockViewFooter from './ClockViewFooter';
import TimeZonesView from './TimeZonesView';
import { ClockPayloadProvider } from '../hooks/useClockPayload';
import type { ClockPayload } from '../schema';

export default observer(function ClockView(props: AssetCommonViewProps<ClockPayload>) {
    return (
        <ClockPayloadProvider value={props.payload}>
            <ClockViewHeader />
            <TimeZonesView />
            <ClockViewFooter />
        </ClockPayloadProvider>
    );
});
